// Components
import Checkbox from '../../../atoms/Checkbox/Checkbox';
// Utils
import cn from '../../../../utils/cn';
// Styles
import styles from './CheckboxCell.module.css';

/**
 * CheckboxCell component for displaying and editing checkbox values in table cells
 * @param {object} props - Component props
 * @param {boolean} props.value - The checkbox value
 * @param {boolean} [props.disabled=false] - Whether the cell is disabled
 * @param {string} [props.id] - Unique identifier for the checkbox
 * @param {(newValue: boolean, event?: React.ChangeEvent<HTMLInputElement>) => void} [props.onChange] - Callback when value changes (second arg: native change event)
 * @param {import('../../../atoms/Checkbox/Checkbox').CheckboxSize} [props.size='small'] - Checkbox size
 * @param {import('../../../atoms/Checkbox/Checkbox').CheckboxTheme} [props.theme='primary'] - Checkbox theme
 * @param {Align} [props.align='left'] - Alignment of the checkbox
 * @param {((props: { className: string }) => React.ReactNode) | null} [props.children] - Children component
 * @returns {JSX.Element} CheckboxCell component
 */
export default function CheckboxCell({
  value = false,
  disabled = false,
  id,
  onChange = () => {},
  size = 'small',
  theme = 'black',
  align = 'left',
  children,
}) {
  /**
   * Handle checkbox change
   * @param {React.ChangeEvent<HTMLInputElement>} event - The event object
   */
  const handleChange = (event) => {
    if (!disabled) {
      const newValue = event.target.checked;
      onChange(newValue, event);
    }
  };

  return (
    <div
      className={cn([
        styles['checkbox-cell'],
        styles[`checkbox-cell-align-${align}`],
      ])}
    >
      {children ? children({ className: styles['checkbox-cell-more-vertical'] }) : null}

      <Checkbox
        id={id}
        checked={value}
        disabled={disabled}
        onChange={handleChange}
        size={size}
        theme={theme}
      />
    </div>
  );
}
